import { isAxiosError } from 'axios';
import { isNil } from 'ramda';
export const isValidationError = (error) => isAxiosError(error) &&
    !isNil(error.response) &&
    error.response.status === 422;
export const isNotFoundError = (error) => isAxiosError(error) &&
    !isNil(error.response) &&
    error.response.status === 404;
export const isServerError = (error) => isAxiosError(error) && !isNil(error.response) && error.response.status >= 500;
export const isForbiddenError = (error) => isAxiosError(error) &&
    !isNil(error.response) &&
    error.response.status === 403;
export const isTooManyRequestsError = (error) => isAxiosError(error) &&
    !isNil(error.response) &&
    error.response.status === 429;
export const isRequestBodyTooLargeError = (error) => isAxiosError(error) &&
    !isNil(error.response) &&
    error.response.status === 413;
export const isWellFormedApiError = (candidate) => (candidate.response?.data &&
    typeof candidate.response.data === 'object' &&
    'errors' in candidate.response.data &&
    typeof candidate.response.data.errors === 'object') === true;
export const isWellFormedGenericApiError = (candidate) => typeof candidate.response?.data === 'object' &&
    candidate.response.data != null &&
    'message' in candidate.response.data &&
    'success' in candidate.response.data &&
    typeof candidate.response.data.success === 'boolean' &&
    !candidate.response.data.success;
